import { instance } from "../../lib/api";
import {
  fetchMetaKey,
  updateMetaKey,
  showError,
  buildUrlWithParams,
  transformApiResponse,
} from "../../containers/DynamicProperties/utils/apiUtils";
import { API_ENDPOINTS } from "../../containers/DynamicProperties/config";

export const GET_DYNAMIC_PROPERTIES = "GET_DYNAMIC_PROPERTIES";
export const CREATE_DYNAMIC_PROPERTY = "CREATE_DYNAMIC_PROPERTY";
export const DYNAMIC_PROPERTY_UPDATED = "DYNAMIC_PROPERTY_UPDATED";

export const getDynamicProperties = () => {
  return async (dispatch) => {
    try {
      // Step 1: Fetch the meta key to get list of all keys
      const keys = await fetchMetaKey();

      if (keys.length === 0) {
        dispatch({
          type: GET_DYNAMIC_PROPERTIES,
          payload: [],
        });
        return;
      }

      // Step 2: Fetch all properties using get-by-keys API
      const keysParam = keys.map((k) => encodeURIComponent(k)).join(",");
      const url = buildUrlWithParams(API_ENDPOINTS.GET_BY_KEYS, {
        keys: keysParam,
      });

      const response = await instance({
        url,
        method: "get",
      });

      const responseData = response.data?.data || [];

      // Step 3: Transform response from propKey/propValue to key/value format
      const transformedData = transformApiResponse(responseData);

      dispatch({
        type: GET_DYNAMIC_PROPERTIES,
        payload: transformedData,
      });
    } catch (err) {
      showError(err, dispatch);
    }
  };
};

export const createDynamicProperty = (key, value) => {
  return async (dispatch) => {
    try {
      // Step 1: Create the property
      const url = buildUrlWithParams(API_ENDPOINTS.CREATE, {
        key,
        value: JSON.stringify(value || {}),
      });

      await instance({
        url,
        method: "post",
      });

      // Step 2: Update the meta key to include the new key
      const existingKeys = await fetchMetaKey();
      if (!existingKeys.includes(key)) {
        const updatedKeys = [...existingKeys, key];
        await updateMetaKey(updatedKeys);
      }

      dispatch({ type: CREATE_DYNAMIC_PROPERTY });
      dispatch(getDynamicProperties());
    } catch (err) {
      showError(err, dispatch);
    }
  };
};

export const updateDynamicProperty = (key, value) => {
  const url = buildUrlWithParams(API_ENDPOINTS.UPDATE, {
    key,
    value: JSON.stringify(value || {}),
  });

  return (dispatch) => {
    return instance({
      url,
      method: "put",
    })
      .then((response) => {
        // Transform the response to match our format
        const responseData = response.data?.data;
        if (responseData) {
          const transformedProperty = transformApiResponse([responseData])[0];

          // Dispatch action to update single property in store
          dispatch({
            type: DYNAMIC_PROPERTY_UPDATED,
            payload: transformedProperty,
          });
        }
      })
      .catch((err) => showError(err, dispatch));
  };
};
